module.exports = __webpack_public_path__ + "static/crunchy_rolls_slika2-496fe7bcd3b98248410dd83870edbe3b.jpg";